module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp1"
  }), _vm._v(" "), _c('p', {
    staticClass: "FMH"
  }, [_c('a', {
    attrs: {
      "id": "pg_vii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "pg_vii"
    }
  }), _c('p', {
    staticClass: "CFMH"
  }, [_c('a', {
    attrs: {
      "id": "pg_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/acknowledgments#ack"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH__1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/prologue#pro"
    }
  }, [_vm._v("Prologue: Condorcet’s Dream")])]), _vm._v(" "), _c('div', {
    staticClass: "cpt-top"
  }, [_c('p', {
    staticClass: "CPT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part1#part1"
    }
  }, [_c('span', {
    staticClass: "SC-B"
  }, [_vm._v("PART I. THE ARTICLES OF THE CONSTITUTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("1.21.")]), _vm._v("   Stand Up and Be Estimated")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("1.22.")]), _vm._v("   (Nearly) Equal Representation")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("1.23.")]), _vm._v("   Weighting for a Fair Vote")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("1.24.")]), _vm._v("   The Impossibility of Democracy")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("1.4.")]), _vm._v("     Dragons and Dummymanders")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("2.1.")]), _vm._v("     The Worst Way to Elect a President, Except for All the Rest")])]), _vm._v(" "), _c('div', {
    staticClass: "cpt-top"
  }, [_c('p', {
    staticClass: "CPT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2#part2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "SC-B"
  }, [_vm._v("PART II. THE BILL OF RIGHTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("A4.1.")]), _vm._v("  Stop and Frisk")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("A4.2.")]), _vm._v("  Reverend Thomas Bayes and the Law")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("A5.")]), _vm._v("     “The Man of Statistics”")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("A6.1.")]), _vm._v("  Despair over Disparity")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("A6.2.")]), _vm._v("  Once Is an Accident …")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("A6.3.")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-STRK"
  }, [_vm._v("12")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-STRK"
  }, [_vm._v("6")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-STRK"
  }, [_vm._v("5")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-STRK"
  }, [_vm._v("10")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("n-")]), _vm._v("Angry Men")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("A8.1.")]), _vm._v("  The Peril and Promise of Social Network Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("A8.2.")]), _vm._v("  Three Strikes for Three Strikes")])]), _vm._v(" "), _c('p', {
    staticClass: "CCTL"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("A8.3.")]), _vm._v("  The Price of Punishment")])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH__1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epilogue#epi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: The Constitutional Equation")])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography#bib",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Select Topical Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Index")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0